import { Spinner } from '@theneatcompany/nui'

export default Spinner
